<script>
import {
  CollectionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-collection-card/collection-card-element-mixin";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "CollectionName",
  elementPanelSettings: {
    displayName: "Collection Name",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "collectionElements",
  },
  extends: UrlElement,
  mixins: [CollectionCardElementMixin],
  computed: {
    label() {
      return this.entity.name;
    },
    computedHref() {
      return useGeneralStore().getRelativeHref(`/collection-items/${this.entity.collectionId}`);
    },
    shouldShowLink() {
      return !!this.label;
    },
  },
};
</script>
